//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPartyVoteLisRank } from '@/api/youzheng'
export default {
  data () {
    return {
      id: this.$route.params.artid,
      obj: [],
      length: []
    }
  },
  created () {
    this.geList()
  },
  methods: {
    geList () {
      getPartyVoteLisRank({
        partyid: this.id
      }).then(data => {
        let totleVoteCnt = 0
        data.obj.forEach((el, index) => {
          if (index < 10) {
            totleVoteCnt = totleVoteCnt + el.tongji
            this.length.push(parseInt((el.tongji / data.obj[0].tongji) * 85) || 0)
            el.phone = el.phone.substr(0, 3) + '****' + el.phone.substr(7)
            this.obj.push(el)
            console.log(this.length)
          }
        })
      })
    }
  }
}
